<template>
  <v-container>
    <v-card
      height="100px"
      width="200px"
      class="pt-2 d-flex flex-column align-center"
      :style="cardStyle"
      outlined
      :ripple="!checked"
      @click="$emit('checkedAttachment', attachment)"
    >
      <v-icon size="40px" :color="attachment.iconColor">
        {{ attachment.icon }}
      </v-icon>
      <v-tooltip bottom color="font" max-width="180">
        <template #activator="{ on }">
          <v-card-text class="subtitle-2 font--text justify-center text-truncate flex-shrink-1" v-on="on">
            {{ attachment.filename }}
          </v-card-text>
        </template>
        <div style="word-break: break-all;">
          {{ attachment.filename }}
        </div>
      </v-tooltip>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'AttachmentTile',
  props: {
    attachment: {
      type: Object,
      required: true,
    },
    checked: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    checkedStyle: {
      border: '1px solid primary',
      'background-color': '#e8f0fe',
    },
    unCheckedStyle: {
      'background-color': 'white',
      color: 'rgba(255,255,255,0)',
    },
  }),
  computed: {
    cardStyle() {
      return this.checked ? this.checkedStyle : this.unCheckedStyle;
    },
  },
};
</script>

<style scoped></style>
